<template>
  <div class="smb-sales_container">
    <div class="smb-sales_container_title">
      Ruijie Sales Information
    </div>
    <div class="smb-sales_container_content">
      <el-form ref="form" label-position="top" :model="formData" :rules="rules" :disabled="isEdit && !isSenior">
        <div class="smb-sales_grid grid-1x2 gap_80">
          <el-form-item prop="salesUserId">
            <template #label>
              <div class="smbsales-label_required">
                Ruijie Sales
              </div>
            </template>
            <el-select
              ref="sales"
              v-model="formData.salesUserId"
              filterable
              remote
              :remote-method="handleSearchUser"
              style="width: 100%; height: 40px"
              @change="handleSelectUserChange"
            >
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.userName"
                :value="item.userId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import API from "@/api";

export default {
  name: "ruijieSalesInformation",
  props: {
    mode: {
      type: String,
      default: 'base'
    },
    isApply: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    // 详情数据
    isDetail: {
      type: Boolean,
      default: false
    },
    detailData: {
      type: Object,
      default: () => {}
    },
    isRenew: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formData: {
        salesName: "",
        salesUserId: ""
      },
      rules: {
        salesUserId: [
          {
            required: true,
            message: "please input sales name",
            trigger: ["change"]
          }
        ]
      },
      userList: []
    };
  },
  computed: {
    // 是否是高级编辑
    isSenior() {
      return this.mode === 'senior'
    }
  },
  methods: {
    handleSearchUser(searchValue, callback) {
      if (!searchValue) return;
      API.getuserslist({
        params: {
          keyword: searchValue,
          userType: 40
        }
      })
        .then(response => {
          let { status, data } = response.data;
          if (status === "200") {
            this.userList = data || [];
            callback && callback();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSelectUserChange(userId) {
      let user = this.userList.find(item => item.userId === userId);
      this.formData.salesName = user.userName;
    },
    // 设置锐捷销售信息
    setRuijieSalesInfo() {
      let user = this.userList.find(
        item => item.userId === this.$store.state.user.userId
      );
      this.formData.salesUserId = user.userId;
      this.formData.salesName = user.userName;
    },
    // 设置表单数据
    setFormData(data) {
      if (!data) return;
      this.formData = JSON.parse(JSON.stringify(data));
      this.handleSearchUser(this.formData.salesName);
    },
    // 获取表单数据
    getFormData() {
      let isPass = false;
      this.$refs.form.validate(isSuccess => {
        isPass = isSuccess;
      });
      if (!isPass) {
        return isPass;
      }
      return JSON.parse(JSON.stringify(this.formData));
    }
  },
  async mounted() {
    if (this.isApply) {
      await this.$store.dispatch("getuser");
      this.handleSearchUser(this.$store.state.user.businessEmail, this.setRuijieSalesInfo);
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/smbSales/components/ruijieSalesInformation.vue